import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { DataStorageService } from './shared/data-storage.service';
import { Subscription } from 'rxjs/Subscription';
import { Router, NavigationStart, NavigationEnd, NavigationCancel } from '../../node_modules/@angular/router';
import { LoaderService } from './shared/loader/loader.service';
import { TranslateService } from '../../node_modules/@ngx-translate/core';

@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit {
    subscription: Subscription;
    user: String;
    title = 'Tour of Heroes';
    constructor(private localStorage: LocalStorageService,
        private router: Router,
        private loaderService: LoaderService,
        private translate:TranslateService
    ) {
        this.translate.setDefaultLang('en');
    }
    isUser: boolean = false;

    ngOnInit() {
        //console.log('app component >>>');
    }

    ngAfterViewInit() {

        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this.loaderService.show();
                }
                else if (
                    event instanceof NavigationEnd ||
                    event instanceof NavigationCancel
                ) {
                    this.loaderService.hide();
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts